import { ButtonGroup } from "@mui/material";
import React from "react";
import RegularButton from "./Button";
import { red, blue, green, yellow, orange } from "@mui/material/colors";

export const ActionsButtons = ({ buttons = [] }) => {
  // Colores por defecto

  const defaultColors = [blue, green, yellow, red, orange];
  // 0 - azul
  // 1 - verde
  // 2 - amarillo
  // 3 - rojo
  // 4 - naranja

  return (
    <ButtonGroup
      size="small"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-end",
      }}
    >
      {buttons.map((btn, idx) => {
        const { Icon, color, validation, intensity, loading, ...rest } = btn;

        return (
          (validation === undefined || validation) && (
            <RegularButton
              round
              justIcon
              size="sm"
              color="transparent"
              key={idx}
              loading={loading}
              {...rest}
            >
              <Icon style={{ color: defaultColors[color][intensity || 500] }} />
            </RegularButton>
          )
        );
      })}
    </ButtonGroup>
  );
};
